export default {
    // C
    createOrganization: 'Create Channel',

    // D
    downloadContent: 'to download this content',

    // I
    interactContent: 'to interact with content',

    // L
    likeContent: 'to like this content',

    // P
    participateConversation: 'to participate in the conversation',
}
